import { render, staticRenderFns } from "./ImagesAddSection.vue?vue&type=template&id=2d062c21&scoped=true&"
import script from "./ImagesAddSection.vue?vue&type=script&lang=js&"
export * from "./ImagesAddSection.vue?vue&type=script&lang=js&"
import style0 from "./ImagesAddSection.vue?vue&type=style&index=0&id=2d062c21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d062c21",
  null
  
)

export default component.exports